<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Público Alvo - Atividade: {{oficina.descricao}}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-publico-alvo-atividade #cadastrarPublicoAlvoAtividade [oficina]="oficina"
                         [perfilAcesso]="perfilAcesso">
        </cadastrar-publico-alvo-atividade>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarPublicosAlvosAtividade.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Público Alvo ( {{ oficina.publicosAlvosAtividade?.length }} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-publico-alvo-atividade #listarPublicosAlvosAtividade
                      [publicosAlvosAtividade]="oficina.publicosAlvosAtividade"
                      (onAtualizarPublicoAlvoAtividade)="onGetAdicionar($event); cadastrarPublicoAlvoAtividade.atualizarPublicoAlvoAtividade($event)"
                      (onAdicionarPublicoAlvoAtividade)="onGetAdicionar($event); cadastrarPublicoAlvoAtividade.cancelar()">
        </listar-publico-alvo-atividade>
    </mat-expansion-panel>
</mat-accordion>
